import gql from 'graphql-tag';

const GET_COUNT = gql`
  {
    filterCount @client
  }
`;

const GET_IS_OPEN = gql`
  {
    filtersIsOpen @client
  }
`;

export { GET_IS_OPEN, GET_COUNT };
